'use client'

import { useLocale } from '@/lib/i18n/use-locale'

export function ErrorContent() {
  const { t } = useLocale()

  return (
    <main className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center px-4">
      <div className="text-center max-w-2xl">
        <div className="mb-8">
          <div className="text-8xl mb-4">🔍</div>
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">{t('error.title')}</h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-6">
            {t('error.subtitle')}
          </p>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 mb-8 text-left shadow-lg">
            <h3 className="font-semibold text-gray-900 dark:text-white mb-3">
              {t('error.whyTitle')}
            </h3>
            <ul className="space-y-2 text-gray-600 dark:text-gray-400">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>{t('error.reasonTyped')}</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>{t('error.reasonDeleted')}</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>{t('error.reasonMissing')}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex gap-4 justify-center">
          <a
            href="/"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition"
          >
            {t('error.goHome')}
          </a>
          <a
            href="/"
            className="inline-block bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 font-semibold py-3 px-8 rounded-lg transition"
          >
            {t('error.createLink')}
          </a>
        </div>
      </div>
    </main>
  )
}
